import { MutationTree } from 'vuex'
import { RouterState } from './types'

export const mutations: MutationTree<RouterState> = {
  sync(state, { to, from }) {
    state.from = from
    state.to = to
  },
}
